/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-text-asset-list-component.ts
 *
 * Created by randysorensen on 9/18/18.
 */

function PackageMediaTextManagerController (
    this: JS5Object,
    _: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.getAcceptTemplate = () => {
        let acceptTemplate: JS5Object;
        if (this.variant === 'cc') {
            acceptTemplate = _.get(this.componentRole, `_ccAcceptTemplate`);
        } else {
            acceptTemplate = _.get(this.componentRole, `_subtitleAcceptTemplate`);
        }
        return acceptTemplate;
    };

    this.getTextTrackList = (): JS5Object[] => {
        let type = this.variant === 'cc' ? 'CC' : 'Subtitle';
        return PackageMediaService.getAssetList(type, this.componentRole);
    };

    this.isEnabled = () => {
        return PackageMediaService.hasMainVideo();
    };

    this.isVisible = () => {
        return PackageMediaService.getValidationStatus(_.toUpper(this.variant), this.componentRole) !== 'NOT APPLICABLE';
    };

    this.getIngestPercent = () => {
        return PackageMediaService.calculateIngestPercent(this.getTextTrackList());
    };

    this.addNewTextTrack = () => {
        PackageMediaService.packageMediaData.assets.push({
            componentRole: _.cloneDeep(this.componentRole),
            type: this.variant === 'cc' ? 'CC' : 'Subtitle'
        });
        PackageUtilService.editorForm.$setDirty();
    };

    this.removeTextTrack = (textTrackAsset: JS5Object) => {
        _.pull(PackageMediaService.packageMediaData.assets, textTrackAsset);
        PackageUtilService.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
    };
}

angular.module('prism-ui.package').component('packageMediaTextAssetList', {
    controller: PackageMediaTextManagerController,
    templateUrl: 'package/editor/components/view/media/assetList/textAssetList/package-media-text-asset-list-template.html',
    bindings: {
        componentRole: '<',
        variant: '<'
    }
});
